import { injectGlobal } from '@emotion/css'

export default injectGlobal({
  '.intercom-lightweight-app': {
    display: 'none',
  },
})
